import module from './gift-list.module';
import _ from 'lodash';

module.controller('GiftListController', [
  'AppService',
  'FriendsService',
  '$stateParams',
  function (AppService, FriendsService, $stateParams) {
    var ctrl = this;
    ctrl.selectedPersonId = Number($stateParams.friendId);
    AppService.pageTitle = 'Gift List';

    ctrl.listIsForRealPerson = function () {
      return ctrl.selectedPersonId !== 0;
    };

    FriendsService.friends.then(function (data) {
      var friend = _.find(data, { id: ctrl.selectedPersonId });

      if (!friend) {
        return;
      }

      ctrl.friendName = friend.name;
      ctrl.friendId = friend.id;
    });

    this.msg = 'Check out these gifts';
  },
]);
